import React, { useEffect, useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { LinksHolder } from '../styled'
import { MenuItem } from './MenuItem'
import { useVisibleMenuItemsContext } from './useVisibleMenuItems'

export const Menu = props => {
  const [open, setIsOpen] = useState(null)
  const {
    visibleMenuItems,
    containerRef,
    setItemRef,
  } = useVisibleMenuItemsContext()

  useEffect(() => {
    setIsOpen(null)
  }, [props.location])

  const onClick = (menuName) => () => {
    setIsOpen(open === menuName ? null : menuName)
  }

  const onOutsideClick = (e) => {
    setIsOpen(null)
  }

  return (
    <LinksHolder ref={containerRef}>
      <OutsideClickHandler display='flex' onOutsideClick={onOutsideClick}>
        {visibleMenuItems.map((menu) => (
          <MenuItem
            key={menu.name}
            ref={setItemRef(menu.name)}
            open={open === menu.name}
            toggleOpen={onClick(menu.name)}
            {...menu}
          />
        ))}
      </OutsideClickHandler>
    </LinksHolder>
  )
}